import { getReq } from '../service/API'
import useSWR from 'swr'
import { getAssignmentsByProjectIdEndpoint } from '../service/api-gateway'
import { EnrollmentWithId, Project, Site } from '../Types'
//import { errorStore } from '../store/ErrorStore'

export const useAssignmentsByProjectId = (projectId: string) => {
  const endOfToday = new Date()
  endOfToday.setHours(23)
  const endOfTodayLocalTime = endOfToday.getTime()

  // we do this so that the cache key only depends on siteId - not Date.now() - same as Sitetool.
  const fetcher = (p: string) => {
    const withTime = p + `/${endOfTodayLocalTime}`
    return getReq(withTime)
  }

  const p = getAssignmentsByProjectIdEndpoint(projectId)

  //const cacheKey = formId ? p : null
  const { data, error, mutate } = useSWR(p, fetcher, { suspense: true })

  const assignments = data?.data as AssignmentsByProjectId | undefined

  if (assignments?.siteEnrollmentsWithCounts) {
    for (const siteData of assignments.siteEnrollmentsWithCounts) {
      if (siteData?.site?.lastMoveAt) {
        const _1weekMs = 1000 * 60 * 60 * 24 * 7
        const flagged = Date.now() - new Date(siteData.site.lastMoveAt).getTime() > _1weekMs
        siteData.site.flagged = flagged
      }
    }
  }

  /*if (error) {
		setError(error.error)
	}*/

  return {
    data: assignments,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}

type AssignmentsByProjectId = {
  project: Omit<Project, 'sites'> & { sites: Site[] }
  siteEnrollmentsWithCounts: siteEnrollmentsWithCounts[]
  showImageEvaluation: boolean
}

export type siteEnrollmentsWithCounts = {
  enrollments: EnrollmentWithId[]
  site: Site & { flagged?: boolean }
  phonescreen: number
  qualifiedLead: number
  scheduled: number
}
